import { ArrowLink, Button, TextButton } from '../../index';
import React from 'react';
import { ImgLazyLoader } from '../../index';
import { CardContainer, CardContent, CardCopy, CardImage, CardTitle } from './Card.style';


type CardProps = React.PropsWithChildren<{
  image: string,
  title: string,
  content: string,
  navigation?: {
    url: string,
    text: string,
  },
}>;

export const Card = ({ image, title, content, navigation } : CardProps) => {
  // FIGURE OUT WHY IMAGES AREN"T UPDATING WHEN SWITCHING FROM /RIAC-BLOG TO /NEWS
  const ImgTag = (
    <ImgLazyLoader>
      <img src={image} alt={title} />
    </ImgLazyLoader>
  );

  const TitleTag = (
    <CardTitle image={!!image}>{title}</CardTitle>
  );

  return (
    <CardContainer>
      {image
        && <CardImage>
          {navigation
            ? <Button to = {navigation.url} aria-label = {navigation.text}>{ImgTag}</Button>
            : <>{ImgTag}</>
          }
        </CardImage>
      }
      <CardContent image={!!image}>

        {navigation
          ? <TextButton to = {navigation.url} aria-label = {navigation.text}>{TitleTag}</TextButton>
          : <>{TitleTag}</>
        }

        <CardCopy>{content}</CardCopy>

        {navigation
        && <ArrowLink to={navigation.url}>{navigation.text}</ArrowLink>
        }
      </CardContent>
    </CardContainer>
  );
};
